<template lang="pug">
div
  #preloader(v-if="loading")
    #loader
</template>
<script>
import config from "@/config";
import errorTags from "@/errorTags";

export default {
  data() {
    return {
      feedback: {
        success: true,
        status: ""
      },
      loading: false,
      mobileDevice: null
    };
  },
  computed: {
    accountID() {
      return this.$store.getters.accountID;
    },
    sessionToken() {
      return this.$store.getters.sessionToken;
    },
  },
  created() {
    var q = this.$route.query;
    this.getMobile()
    this.paymentGateWaySubmit(q.amount,q.promo, q.method);
  },
  methods: {
    getMobile() {
      if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
        this.mobileDevice = 1
      }else{
        this.mobileDevice = 0
      }
    },
    paymentGateWaySubmit(deposit_amount, package_id, method) {
      if(package_id === '0'){
        package_id = ""
      }  
      if (this.accountID && this.sessionToken) {
        this.loading = true
        let account_id = this.accountID;
        let auth_token = this.sessionToken;
        let return_url = window.location.protocol + "//" +window.location.hostname
        let channel = method
        let is_mobile = this.mobileDevice
        this.$store
          .dispatch("user/epicPay", {
            account_id,
            deposit_amount,
            package_id,
            auth_token,
            channel,
            return_url,
            is_mobile
          })
          .then(response => {
            this.loading = false;
            this.feedback.success = response.success;
            this.feedback.status = response.status;
            if (this.feedback.success == true) {
              window.location.href= response.data
            } else {
              var vm = this;
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            this.loading = false;
            this.feedback.success = false;
            var vm = this;
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this);
            }
            this.feedback.status = this.$t("error." + response.status);
          });
      }
    }
  }
};
</script>
